import { render, staticRenderFns } from "./AppDetailCard.vue?vue&type=template&id=57441702"
import script from "./AppDetailCard.vue?vue&type=script&lang=js"
export * from "./AppDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports